import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    requestPushToken?: () => void;
  }
}

const STORAGE_KEY = 'device_token_registered';

export function useAutoDeviceRegistration() {
  const requestedRef = useRef(false);

  useEffect(() => {
    if (requestedRef.current) return;

    const alreadyRegistered = localStorage.getItem(STORAGE_KEY);
    if (alreadyRegistered) {
      requestedRef.current = true;
      return;
    }

    const requestToken = () => {
      if (requestedRef.current) return;
      requestedRef.current = true;

      // Ask the native app wrapper to provide the FCM token
      // The native app should call window.registerPushToken() in response
      if (window.requestPushToken) {
        window.requestPushToken();
      }
    };

    const events = ['touchstart', 'click', 'scroll', 'keydown'];

    const handler = () => {
      events.forEach(e => document.removeEventListener(e, handler));
      requestToken();
    };

    events.forEach(e => document.addEventListener(e, handler, { once: true, passive: true }));

    return () => {
      events.forEach(e => document.removeEventListener(e, handler));
    };
  }, []);
}
